// extracted by mini-css-extract-plugin
export var image = "index-module--image--qOzsC";
export var imageContainer = "index-module--imageContainer--o5Taz";
export var imageWrapper = "index-module--imageWrapper--a-ovy";
export var logo = "index-module--logo--QzEob";
export var logoContainer = "index-module--logoContainer--TAssf";
export var logoImagesContainer = "index-module--logoImagesContainer--kUh0z";
export var logoWrapper = "index-module--logoWrapper--KS4ur";
export var slick = "index-module--slick--N0jcX";